import React from 'react';
import { NavLink } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';

import ProductAPI from '../../../api/ProductAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';


class ProductList extends React.Component {

  constructor(props) {
    super(props);
    this.products = [];
    this.state = { ...this.state, product: {}, popup: false, inApiCall: true };
    this.path = this.props.match.path;
    const modelCat = reactLocalStorage.getObject(Const.Model).product_category;
    this.catOptions = modelCat.options;

    const modelUnit = reactLocalStorage.getObject(Const.Model).unit_measure;
    this.unitOptions = modelUnit.options;

    const model = reactLocalStorage.getObject(Const.Model).product;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.Import = Util.isAllow(model.permission, Const.PermImport);
    this.CatList = Util.isAllow(modelCat.permission, Const.PermView);
    this.UnitList = Util.isAllow(modelUnit.permission, Const.PermView);
  }

  componentDidMount() { if (this.List) ProductAPI.list(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = products => { this.products = products; this.setState({ inApiCall: false }); };

  show = i => {
    let product;
    if (i === -1) {
      product = { id: 0, name: '', price: 0, tax: 0, category: 0, unit_measure: 0 };
    } else {
      product = {
        id: this.products[i].id, name: this.products[i].name,
        price: this.products[i].price, tax: this.products[i].tax,
        category: this.products[i].category, unit_measure: this.products[i].unit_measure
      };
    }
    this.setState({ ...this.state, product: product, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.product.name.trim().length === 0) {
      return;
    }
    this.setState({ ...this.state, popup: false, inApiCall: true });
    ProductAPI.save(this.state.product, this.success, this.onFail);
  };
  success = () => {
    Util.showNotification('Successful', 'Product successfully saved', 'success');
    this.props.onModuleChanged();
    ProductAPI.list(this.onReceived, this.onFail);
  };
  onChange = (field, val) => {
    const product = { ...this.state.product };
    product[field] = val;
    this.setState({ ...this.state, product: { ...product } });
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.products[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ProductAPI.delete(this.products[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Product Deleted successfully', 'success');
    ProductAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const productUI = this.products.map((product, _i) => (
      <tr key={`product_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{product.name}</td>
        <td>{product.price}</td>
        <td>{product.tax}</td>
        <td>{Display.ModelLabelValue('product_category', product.category)}</td>
        <td>{Display.ModelLabelValue('unit_measure', product.unit_measure)}</td>
        <td>{Display.ModelLabelValue('user', product.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(product.created_date)}</td>
        <td>{Display.ModelLabelValue('user', product.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(product.updated_date)}</td>
        <td>
          {this.Update &&
            <div className="buttons success" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update</div>
          }
          {product.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete</div>
          }
        </td>
      </tr>
    ));

    let option = this.catOptions.find(option => option.value === this.state.product.category);
    const catSelections = option ? [option] : [];
    option = this.unitOptions.find(option => option.value === this.state.product.unit_measure);
    const unitSelections = option ? [option] : [];
    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Product</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Name"
                    className="mr-sm-2"
                    value={this.state.product.name}
                    onChange={event => this.onChange('name', event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Price"
                    className="mr-sm-2"
                    value={this.state.product.price}
                    onChange={event => this.onChange('price', event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Tax</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Product Price"
                    className="mr-sm-2"
                    value={this.state.product.tax}
                    onChange={event => this.onChange('tax', event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Category</Form.Label>
                  <Select value={catSelections}
                    onChange={select => this.onChange('category', select ? select.value : 0)}
                    options={this.catOptions} isSearchable={true} isClearable={true} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Unit of Measurement</Form.Label>
                  <Select value={unitSelections}
                    onChange={select => this.onChange('unit_measure',
                      select !== null ? select.value : 0)}
                    options={this.unitOptions} isSearchable={true} isClearable={true} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pb-3"><h3>Products</h3></div>
              <div className="col-md-8 text-right pb-3">
                {this.UnitList &&
                  <NavLink to={`${this.path}/measure-unit`} className="success buttons">
                    Unit Measure List</NavLink>
                }
                {this.CatList &&
                  <NavLink to={`${this.path}/category`} className="success buttons">
                    Product Category List</NavLink>
                }
                {this.Import &&
                  <NavLink to={`${this.path}/import`} className="success buttons">
                    Product Import</NavLink>
                }
                {this.Add &&
                  <span className="success buttons pcat" onClick={() => this.show(-1)}>
                    + Add Product</span>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Price</th>
                      <th>Tax</th>
                      <th>Category</th>
                      <th>Unit of Measurement</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {productUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ProductList);
